// eslint-disable-next-line import/prefer-default-export
export const SUBMIT = 'SUBMIT';
export const LOAD = 'LOAD';
export const LOAD_SEARCH = 'LOAD_SEARCH';
export const INIT = 'INIT';
export const GET = 'GET';
export const ADD = 'ADD';
export const DELETE = 'DELETE';


export const STATUS = 'STATUS';
export const GET_USER_DISPLAY_NAME = 'GET_USER_DISPLAY_NAME';
export const LOAD_REPS_BY_FIRM = 'LOAD_REPS_BY_FIRM';
